import { Cookies } from 'app_alegra_commons/libs'
import ENVIRONMENT from '../../../environment.json'

const VUE_APP_ENVIROMENT = process.env.VUE_APP_ENVIROMENT || 'local'

export const getCookie = (name: string) => {
  return Cookies.get(ENVIRONMENT[VUE_APP_ENVIROMENT][name])
}

export const setCookie = (name: string, value: string) => {
  Cookies.set(ENVIRONMENT[VUE_APP_ENVIROMENT][name], value)
}

export const removeCookie = (name: string) => {
  Cookies.remove(ENVIRONMENT[VUE_APP_ENVIROMENT][name])
}
